import featureConstants from '../../constants/featureConstants';
import { isFeatureActive } from '../../redux/reducers/config/configReducer';

function isPayPalAvailable(state) {
  return !state?.user?.partnerDiscountEnabled && !isFeatureActive(state, featureConstants.DISABLE_PAYPAL);
}

export default isPayPalAvailable;
